(function () {
  var burger = document.querySelector('[data-burger]');
  var nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('.pdp__main img');
      if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-thumb'); }
    });
  });

  var pf = document.querySelector('[data-pf]');
  var pj = document.querySelector('[data-product-json]');
  if (!pf || !pj) return;
  var product = JSON.parse(pj.textContent);
  var selects = pf.querySelectorAll('[data-opt]');
  var vid = pf.querySelector('[data-vid]');
  var priceEl = document.querySelector('[data-price]');
  var eachEl = document.querySelector('[data-each]');
  var addBtn = pf.querySelector('[data-add]');
  var tiers = document.querySelector('[data-tiers]');
  var qtyIdx = -1;
  product.options.forEach(function (o, i) { if (String(o.name || o).toLowerCase() === 'quantity') qtyIdx = i; });

  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function num(s) { var n = parseInt(String(s).replace(/,/g, ''), 10); return isNaN(n) ? 0 : n; }
  function current() {
    var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
    return product.variants.find(function (v) {
      return vals.every(function (val, i) { return v.options[i] === val; });
    });
  }
  function renderTiers(v) {
    if (!tiers || qtyIdx < 0) return;
    var rows = product.variants.filter(function (x) {
      return x.options.every(function (o, i) { return i === qtyIdx || o === v.options[i]; });
    });
    tiers.innerHTML = rows.map(function (x) {
      var q = num(x.options[qtyIdx]);
      return '<tr' + (x.id === v.id ? ' style="font-weight:700"' : '') + '><td>' + x.options[qtyIdx] + '</td><td>' + money(x.price) + '</td><td>' + (q ? money(Math.round(x.price / q)) : '') + '</td></tr>';
    }).join('');
  }
  function update() {
    var v = current();
    if (!v) {
      addBtn.disabled = true; addBtn.textContent = 'Not available in this combination';
      return;
    }
    vid.value = v.id;
    priceEl.textContent = money(v.price);
    if (qtyIdx >= 0 && eachEl) {
      var q = num(v.options[qtyIdx]);
      eachEl.textContent = q ? '(' + money(Math.round(v.price / q)) + ' each for ' + v.options[qtyIdx] + ')' : '';
    }
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Call for availability';
    renderTiers(v);
    var u = new URL(window.location.href);
    u.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', u.toString());
  }
  selects.forEach(function (s) { s.addEventListener('change', update); });
  if (selects.length) update();

  var file = pf.querySelector('[data-file]');
  pf.addEventListener('submit', function (e) {
    if (file && file.files[0] && file.files[0].size > 20 * 1024 * 1024) {
      e.preventDefault();
      alert('That file is over 20 MB. Add to cart without it and email the file with your order number.');
    }
  });
})();
